<template>
  <div>
    <headers />
    <div class="jie">
      <div class="clearfix containers">
        <el-breadcrumb
          separator-class="el-icon-arrow-right"
          class="containers breadcrumb"
          style="  opacity: 0.6"
        >
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/teacherlist' }">名师专区</el-breadcrumb-item>
          <el-breadcrumb-item>{{teachercontent.name}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="share clearfix">
          <div class="kuai fr clearfix">
            分享
            <share :config="config" class="fr"></share>
          </div>
          <div class="fr">
            <span class="teachershare" v-if="teachercontent.isCollect == 1" @click="yi_follow">
              <i class="iconfont icon-guanzhuzuozheyiguanzhu" style="font-size:18px;"></i>
              已关注
            </span>
            <span class="teachershare" v-else @click="follow">
              <i class="iconfont icon-guanzhu"></i>
              关注
            </span>
          </div>
        </div>
        <div class="wherebox clearfix">
          <div class="pic on">
            <img :src="teachercontent.avatar" alt />
          </div>
          <div class="infos">
            <h3>
              <span>{{teachercontent.name}}</span>
              <i>{{teachercontent.schoolName}}</i>
            </h3>
            <div class="spanl">
              课程数量:{{teachercontent.commentCount}}
              <i></i>
              关注人数：{{teachercontent.collectCount}}
            </div>
            <div class="ratebox clearfix" v-if="teachercontent.score!=undefined">
              <el-rate
                v-model="teachercontent.score"
                disabled
                show-score
                text-color="#ff9900"
                :score-template="(teachercontent.score.toString())"
                class="fl rate"
              ></el-rate>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="containers clearfix choosebox" style="margin-top:43px">
      <div class="chooseboxleft" style="padding:0">
        <div class="tabbox on">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="讲师课程" name="0"></el-tab-pane>
            <el-tab-pane label="讲师评价" name="1"></el-tab-pane>
          </el-tabs>

          <div class="tags" style="left:183px;">{{pingjia==null?0:pingjia.count}}</div>
        </div>
        <!-- 讲师课程 -->
        <div v-if="activeName==0">
          <div
            class="classitems clearfix"
            v-for="(item) in classboxs"
            :key="item.id"
            :data-id="item.id"
          >
            <div class="pic fl">
              <img :src="item.imgUrl" alt />
              <div class="type" v-if="item.type == 1">点播课</div>
              <div class="type" v-if="item.type == 2">直播课</div>
              <div class="type" v-if="item.type == 3">线下课</div>
            </div>
            <div class="infos clearfix fr">
              <h3>{{item.title}}</h3>
              <div class="zai">
                <i class="el-icon-s-custom"></i>
                {{item.count}}人在学
              </div>
              <div class="hou clearfix">
                <div class="money fl">{{item.price == 0?'免费':'¥'+item.price}}</div>
                <router-link
                  tag="div"
                  :to="{path:'/detailsclass',query:{id:item.id}}"
                  class="btn fr on"
                  v-if="item.isJoin == 1"
                >去学习</router-link>
                <router-link
                  tag="div"
                  :to="{path:'/detailsclass',query:{id:item.id}}"
                  class="btn fr"
                  v-else
                >立即参加</router-link>
              </div>
            </div>
          </div>
          <div class="pageing" v-if="classboxs.length != 0">
            <span class="spansx" @click="pageindex" :class="[page == 1?'on':'']">首页</span>
            <el-pagination
              small
              layout="prev, pager, next"
              prev-text="上一页"
              next-text="下一页"
              :background="true"
              :total="teacherarrsss.total_pages==null?1:teacherarrsss.total_pages"
              :page-size="1"
              @current-change="currentchange"
              :current-page="page"
            ></el-pagination>
            <span
              @click="pageend"
              class="spansx"
              :class="[page == teacherarrsss.total_pages?'on':'']"
            >尾页</span>
          </div>
        </div>
        <!-- 机构课程结束 -->

        <!-- 评价 -->
        <div v-if="activeName == 1">
          <div class="zong on">
            <span class="asspan">{{teachercontent.score}}</span>
            <div class="zhi" v-if="pingjia != undefined">
              <el-rate
                v-model="teachercontent.score"
                disabled
                show-score
                text-color="#ff9900"
                score-template
              ></el-rate>
              <i class="ibox">共{{pingjia==null?0:pingjia.count}}条评价</i>
            </div>
          </div>
          <ul class="pinbox on">
            <li class="clearfix" v-for="(item) in pingjia.arr" :key="item.id" :data-id="item.id">
              <el-avatar :size="30" :src="item.avatar" class="fl"></el-avatar>
              <div class="infos fl">
                <em>{{item.name}}</em>
                <el-rate
                  v-model="item.score"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template
                ></el-rate>
                <p>{{item.content}}</p>
                <div class="time">{{item.date}}</div>
              </div>
            </li>
          </ul>
          <div class="pageing" v-if="pingjia.arr.length != 0">
            <span class="spansx" @click="pageindex_p" :class="[page_p == 1?'on':'']">首页</span>
            <el-pagination
              small
              layout="prev, pager, next"
              prev-text="上一页"
              next-text="下一页"
              :background="true"
              :total="pingjia.total_pages==null?1:pingjia.total_pages"
              :page-size="1"
              @current-change="currentchange_P"
              :current-page="page_p"
            ></el-pagination>
            <span @click="pageend_p"
              class="spansx"
              :class="[page_p == pingjia.total_pages?'on':'']">尾页</span>
          </div>
        </div>
      </div>
      <div class="chooseboxr">
        <div class="introductionteacher">
          <h3>讲师简介</h3>
          <p v-html="teachercontent.info"></p>
        </div>
        <div class="tuibox">
          <h3>推荐课程</h3>
          <router-link
            tag="div"
            :to="{path:'/detailsclass',query:{id:item.id}}"
            class="item clearfix"
            v-for="(item) in teachercontent.hot_course"
            :key="item.id"
            :data-id="item.id"
          >
            <div class="pic">
              <img :src="item.imgUrl" />
            </div>
            <div class="infos">
              <h4>{{item.title}}</h4>
              <span v-if="item.type == 1">点播课</span>
              <span v-if="item.type == 2">直播课</span>
              <span v-if="item.type == 3">线下课</span>
              <div class="money">{{item.price == 0?'免费':'¥'+item.price}}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import utilFile from "@/ace/ace.js";
import getPointNum from "@/tools/tools.js";
import {
  Breadcrumb,
  BreadcrumbItem,
  Rate,
  Button,
  Tabs,
  TabPane,
  Icon,
  Pagination,
  Avatar,
  Message
} from "element-ui";
export default {
  components: {
    headers,
    footers,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Rate.name]: Rate,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Icon.name]: Icon,
    [Pagination.name]: Pagination,
    [Avatar.name]: Avatar,
    [Message.name]: Message
  },
  data() {
    return {
      switchs: false,
      value: 3,
      activeName: 0,
      zong: 4.9,
      circleUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      teachercontent: "",
      page: 1,
      page_p: 1,
      classboxs: [],
      teacherarrsss: {},
      pingjia: {},
      config: {
        url: window.location.href,
        sites: ["wechat", "weibo", "qq"], // 启用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>"
      }
    };
  },
  watch: {
    activeName(newvalue) {
      if (newvalue == 0) {
        this.page = 1;
        this.page_p = 1;
        this.teacherclass();
      } else if (newvalue == 1) {
        this.page = 1;
        this.page_p = 1;
        this.teacherpingjia();
      }
    },
    page(newvalue) {
      this.page = newvalue;
      this.teacherclass();
    },
    page_p(newvalue) {
      this.page_p = newvalue;
      this.teacherpingjia();
    }
  },
  methods: {
    handleClick(tab, event) {},
    jiaotifunc() {
      var data = {
        teacher_id: this.$route.query.id
      };
      data = utilFile.encrypt(JSON.stringify(data));

      this.$axios({
        method: "post",
        url: `/index/teacher.detail?parameter=${data}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 90005) {
          Message.closeAll();
          Message({
            showClose: true,
            message: "该教师已下架",
            type: "warning"
          });
          setTimeout(() => {
            this.$router.back();
          }, 1000);
        }
        if (res.data.data != undefined) {
          let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
          totaldata.score = getPointNum.getPointNum(totaldata.score, 2);
          this.teachercontent = totaldata;
        }
      });
    },
    //课程分页
    currentchange(page) {
      this.page = page;
    },
    pageindex() {
      this.page = 1;
    },
    pageend() {
      this.page = this.teacherarrsss.total_pages;
    },
    //评价分页
    currentchange_P(page_p) {
      this.page_p = page_p;
    },
    pageindex_p() {
      this.page_p = 1;
    },
    pageend_p() {
      this.page_p = this.pingjia.total_pages;
    },

    teacherclass() {
      var data = {
        teacher_id: this.$route.query.id,
        page: this.page
      };
      data = utilFile.encrypt(JSON.stringify(data));

      this.$axios({
        method: "post",
        url: `/index/teacher.getCourse?parameter=${data}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.data != undefined) {
          let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
          this.teacherarrsss = totaldata;
          this.classboxs = totaldata.arr;
          this.count = totaldata.total_pages;
        }
      });
    },
    teacherpingjia() {
      var data = {
        teacher_id: this.$route.query.id,
        page: this.page
      };
      data = utilFile.encrypt(JSON.stringify(data));

      this.$axios({
        method: "post",
        url: `/api/teacher.getComment?parameter=${data}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.data != undefined) {
          let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
          
          totaldata.arr.forEach((item,index) => {
            item.score = getPointNum.getPointNum(item.score,2);
          });

          this.pingjia = totaldata;

        }
      });
    },
    //关注
    follow() {
      var data = utilFile.encrypt(
        JSON.stringify({
          teacher_id: this.$route.query.id
        })
      );

      this.$axios({
        method: "post",
        url: `/api/user.addTeacherCollection?parameter=${data}`,
        data: data,
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
          this.teachercontent.isCollect = 1;
          this.teachercontent.collectCount++;
        } else if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        } else {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "warning"
          });
        }
      });
    },

    yi_follow() {
      var data = utilFile.encrypt(
        JSON.stringify({
          teacher_id: this.$route.query.id
        })
      );

      this.$axios({
        method: "post",
        url: `/api/user.delTeacherCollection?parameter=${data}`,
        data: data,
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
          this.teachercontent.isCollect = 0;
          this.teachercontent.collectCount--;
        } else if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        } else {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "warning"
          });
        }
      });
    }
  },
  mounted() {
    this.jiaotifunc();
    this.teacherpingjia(); //评价
  }
};
</script>

<style scoped>
@import "~@/assets/css/common.css";

</style>